<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <!-- MOBILE VIEW -->
    <div class="content d-lg-none mob-po-summary">
      <!-- Header & Search -->
      <div class="px-2 mb-4">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <div class="d-flex align-items-center gap-3">
            <a href="javascript:void(0);" @click="$router.push('/purchases/order-list')" class="btn-back-mob shadow-sm">
              <vue-feather type="arrow-left" size="20"></vue-feather>
            </a>
            <h4 class="fw-bold mb-0">PO Kios</h4>
          </div>
        </div>
        
        <div class="search-input-mob shadow-xs">
          <vue-feather type="search" size="18" class="text-muted"></vue-feather>
          <input type="text" v-model="searchQuery" placeholder="Cari Kios..." class="border-0 bg-transparent w-100 ms-2" />
        </div>
      </div>

      <!-- Kios List Cards -->
      <div class="px-2 pb-5">
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-success" role="status"></div>
        </div>
        
        <div v-else-if="filteredMembers.length > 0">
          <div 
            v-for="kios in filteredMembers" 
            :key="'mob-kios-'+kios.id" 
            class="mob-kios-card mb-3 p-0 bg-white"
            @click="showSummary(kios)"
            style="cursor: pointer;"
          >
            <div class="d-flex p-3 align-items-center">
              <div class="flex-shrink-0 me-3">
                <img :src="getImageUrl(kios.foto_toko)" class="rounded-3 shadow-xs" style="width: 56px; height: 56px; object-fit: cover;">
              </div>
              <div class="flex-fill">
                <h6 class="fw-bold text-dark mb-1">{{ kios.nama_toko }}</h6>
                <div class="d-flex justify-content-between align-items-center">
                  <span class="small text-muted">{{ kios.nama_member }}</span>
                  <button class="btn btn-success-soft btn-sm rounded-pill px-3 py-1" @click.stop="showSummary(kios)">
                    <vue-feather type="list" size="12" class="me-1"></vue-feather>
                    <span class="smallest fw-bold">LIHAT PO</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Empty State Mobile -->
        <div v-else class="text-center py-5">
          <div class="bg-light p-4 rounded-circle d-inline-block mb-3">
            <vue-feather type="home" class="text-muted" size="40"></vue-feather>
          </div>
          <p class="text-muted small">Tidak ada data Kios ditemukan.</p>
        </div>
      </div>
    </div>

    <!-- DESKTOP VIEW -->
    <div class="content d-none d-lg-block">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Ringkasan PO Kios</h4>
            <h6>Pantau total pesanan per Kios SSP</h6>
          </div>
        </div>
      </div>

      <!-- Main Content -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top mb-4">
            <div class="search-set">
              <div class="search-input">
                <input 
                  type="text" 
                  placeholder="Cari Kios (Nama Pemilik/Nama Toko)..." 
                  class="dark-input" 
                  v-model="searchQuery"
                />
                <a href="javascript:void(0);" class="btn btn-searchset">
                  <vue-feather type="search" class="feather-search"></vue-feather>
                </a>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table datanew">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Kios (Toko)</th>
                  <th>Nama Pemilik</th>
                  <th class="text-center">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(kios, index) in filteredMembers" :key="kios.id">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <div class="userimgname">
                      <div class="product-img">
                        <img :src="getImageUrl(kios.foto_toko)" alt="img" class="rounded" />
                      </div>
                      <div class="ms-2">
                        <h6 class="fw-bold">{{ kios.nama_toko }}</h6>
                        <span class="small text-muted">{{ kios.nama_member }}</span>
                      </div>
                    </div>
                  </td>
                  <td>{{ kios.nama_member }}</td>
                  <td class="text-center">
                    <button 
                      class="btn btn-success btn-sm rounded-pill px-3"
                      @click="showSummary(kios)"
                    >
                      <vue-feather type="list" size="14" class="me-1"></vue-feather>
                      Lihat Ringkasan PO
                    </button>
                  </td>
                </tr>
                <tr v-if="filteredMembers.length === 0">
                  <td colspan="4" class="text-center py-5">
                    <div class="text-muted">Tidak ada data kios ditemukan.</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Summary Modal (Shared between mobile and desktop) -->
    <div class="modal fade" id="summaryModal" tabindex="-1" aria-hidden="true" ref="summaryModal">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content overflow-hidden border-0 shadow-lg" style="border-radius: 20px;">
          <div class="modal-header bg-success text-white p-4">
            <div class="d-flex align-items-center">
               <div class="bg-white rounded-circle p-2 me-3 shadow-sm d-flex align-items-center justify-content-center" style="width: 48px; height: 48px;">
                  <vue-feather type="shopping-bag" class="text-success"></vue-feather>
               </div>
               <div>
                  <h5 class="modal-title fw-800 text-white mb-0" id="filterModalLabel">Ringkasan PO Kios</h5>
                  <p class="small text-white-50 mb-0 opacity-75">{{ selectedKios?.nama_toko }} - {{ selectedKios?.nama_member }}</p>
               </div>
            </div>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body p-4 bg-light-soft">
            <div v-if="loadingSummary" class="text-center py-5">
              <div class="spinner-border text-success" role="status"></div>
              <p class="mt-2 text-muted">Mengambil data...</p>
            </div>
            <div v-else>
              <div v-if="summaryItems.length > 0">
                <div class="row g-3">
                  <div v-for="item in summaryItems" :key="item.produk + item.sumber_barang" class="col-md-6 col-lg-4 col-12">
                    <div class="card h-100 border-0 shadow-xs rounded-4 overflow-hidden mb-0">
                      <div class="card-body p-3">
                        <div class="d-flex flex-column h-100">
                          <label class="smallest fw-800 text-muted uppercase tracking-wider mb-2">PRODUK</label>
                          <h6 class="fw-bold text-dark mb-1">{{ item.produk }}</h6>
                          <div class="mt-2 py-2 px-3 bg-success-soft rounded-pill d-inline-flex align-items-center gap-2" style="width: fit-content;">
                             <span class="fw-800 text-success">{{ item.quantity_box }} {{ item.qty_type ? item.qty_type.toUpperCase() : 'DUS' }}</span>
                          </div>
                          <hr class="my-3 opacity-25">
                          <div class="mt-auto">
                            <div class="d-flex align-items-center gap-1 text-muted smallest fw-bold uppercase">
                              <vue-feather type="truck" size="10"></vue-feather>
                              {{ item.sumber_barang }}
                            </div>
                            <small class="text-muted d-block mt-1">Terakhir: {{ formatDate(item.tanggal) }}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="text-center py-5 bg-white rounded-4 shadow-xs">
                <div class="bg-light-soft p-4 rounded-circle d-inline-block mb-3">
                  <vue-feather type="package" class="text-muted" size="48"></vue-feather>
                </div>
                <h5 class="fw-bold">Belum Ada Transaksi</h5>
                <p class="text-muted small">Kios ini belum memiliki riwayat pesanan.</p>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0 p-4 bg-white">
            <button type="button" class="btn btn-light-soft rounded-pill px-4 fw-bold" data-bs-dismiss="modal">TUTUP</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import memberService from '@/services/memberService';
import { Modal } from 'bootstrap';

export default {
  setup() {
    const searchQuery = ref('');
    const members = ref([]);
    const loading = ref(true);
    const selectedKios = ref(null);
    const summaryItems = ref([]);
    const loadingSummary = ref(false);
    const summaryModalRef = ref(null);
    let modalInstance = null;

    const apiBaseUrl = (process.env.VUE_APP_API_URL || '/api/v1').replace(/\/api\/v1$/, '');

    const getImageUrl = (path) => {
      if (!path) return '/assets/img/placeholder.jpg';
      if (path.startsWith('http')) return path;
      const formattedPath = path.startsWith('/') ? path : `/${path}`;
      return `${apiBaseUrl}${formattedPath}`;
    };

    const formatDate = (dateStr) => {
      if (!dateStr) return '-';
      const date = new Date(dateStr);
      return date.toLocaleDateString('id-ID', { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      });
    };

    const loadMembers = async () => {
      loading.value = true;
      try {
        const response = await memberService.getMembers({ limit: 1000 });
        members.value = response.items || [];
      } catch (error) {
        console.error('Error fetching members:', error);
      } finally {
        loading.value = false;
      }
    };

    const filteredMembers = computed(() => {
      if (!searchQuery.value) return members.value;
      const q = searchQuery.value.toLowerCase();
      return members.value.filter(m => 
        m.nama_toko.toLowerCase().includes(q) || 
        m.nama_member.toLowerCase().includes(q) ||
        m.kode_barcode.toLowerCase().includes(q)
      );
    });

    const showSummary = async (kios) => {
      selectedKios.value = kios;
      loadingSummary.value = true;
      summaryItems.value = [];
      
      if (!modalInstance) {
        modalInstance = new Modal(document.getElementById('summaryModal'));
      }
      modalInstance.show();

      try {
        const response = await memberService.getMemberOrderSummary(kios.id);
        summaryItems.value = response;
      } catch (error) {
        console.error('Error fetching summary:', error);
      } finally {
        loadingSummary.value = false;
      }
    };

    onMounted(() => {
      loadMembers();
    });

    return {
      searchQuery,
      loading,
      filteredMembers,
      selectedKios,
      summaryItems,
      loadingSummary,
      showSummary,
      getImageUrl,
      formatDate
    };
  }
};
</script>

<style scoped>
.bg-light-soft {
  background-color: #f8faf9;
}
.bg-success-soft {
  background-color: rgba(2, 145, 71, 0.1);
}
.shadow-xs {
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
}
.rounded-4 {
  border-radius: 1rem !important;
}
.smallest {
  font-size: 10px;
}
.fw-800 {
  font-weight: 800;
}
.letter-spacing-1 {
  letter-spacing: 1px;
}
.userimgname {
  display: flex;
  align-items: center;
}
.product-img {
  width: 40px;
  height: 40px;
}
.product-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Mobile Styles */
.mob-po-summary {
  padding-top: 15px !important;
  background: #fdfdfd;
}

.btn-back-mob {
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e293b;
  border: 1px solid #f1f5f9;
  transition: all 0.2s;
}

.btn-back-mob:active {
  transform: scale(0.9);
  background: #f8fafc;
}

.search-input-mob {
  background: white;
  border-radius: 16px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  border: 1px solid #f1f5f9;
}

.mob-kios-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  border: 1px solid #f1f5f9;
  transition: all 0.2s;
}

.mob-kios-card:active {
  transform: scale(0.98);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.btn-success-soft {
  background-color: rgba(2, 145, 71, 0.1);
  color: #029147;
  border: none;
  font-weight: 700;
}

.btn-success-soft:hover,
.btn-success-soft:active {
  background-color: rgba(2, 145, 71, 0.15);
  color: #029147;
}

.btn-light-soft {
  background-color: #f8fafc;
  color: #64748b;
}
</style>
